import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, FileText, Loader2 } from 'lucide-react';
import { getExpenseReceiptItems, openExpenseReceipt } from '@/utils/expenseDisplay';
import { toast } from 'sonner';

export default function ExpenseReportReceipts({ report, className = '' }) {
  const { t } = useTranslation();
  const items = getExpenseReceiptItems(report);
  const [openingIdx, setOpeningIdx] = useState(null);

  if (!items.length) return null;

  const handleOpen = async (item, idx) => {
    setOpeningIdx(idx);
    try {
      const ok = await openExpenseReceipt(item.url);
      if (!ok) {
        toast.error(
          t('admin_expense_receipt_open_failed', {
            defaultValue: 'No se pudo abrir el ticket PDF',
          }),
        );
      }
    } finally {
      setOpeningIdx(null);
    }
  };

  return (
    <div className={`p-3 bg-gray-50 rounded border ${className}`.trim()}>
      <h4 className="font-semibold text-sm mb-2 flex items-center gap-1">
        <Image className="w-4 h-4" />
        {t('admin_tickets_receipts', { count: items.length })}
      </h4>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
        {items.map((item, idx) => (
          <div
            key={item.id || idx}
            className="border rounded overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow"
          >
            {item.isPdf ? (
              <button
                type="button"
                onClick={() => handleOpen(item, idx)}
                disabled={openingIdx === idx}
                className="flex flex-col items-center justify-center h-32 w-full p-2 text-blue-700 hover:bg-blue-50 disabled:opacity-60"
                data-testid={`expense-receipt-pdf-${idx}`}
              >
                {openingIdx === idx ? (
                  <Loader2 className="w-10 h-10 mb-1 animate-spin" />
                ) : (
                  <FileText className="w-10 h-10 mb-1" />
                )}
                <span className="text-xs font-medium text-center">
                  {t('admin_expense_receipt_pdf')}
                </span>
              </button>
            ) : (
              <img
                src={item.url}
                alt={t('admin_ticket_label', { n: idx + 1 })}
                className="w-full h-32 object-cover cursor-pointer hover:opacity-80"
                onClick={() => handleOpen(item, idx)}
              />
            )}
            <div className="p-1 text-center text-[10px] text-gray-600">
              {t('admin_ticket_label')} {idx + 1}
              {item.type ? ` · ${item.type}` : ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
